import { ExternalLink } from '@uikit/index';

import { DISCORD_URL } from '@shared/constants';

export const ListFooter = () => {
  return (
    <p className="text-base-text-secondary body-md-adaptive">
      If you encounter any issues with the Pool, kindly visit our{' '}
      <ExternalLink className="text-base-text-pink" href={DISCORD_URL}>
        Discord
      </ExternalLink>{' '}
      and open a Support Ticket for assistance.
    </p>
  );
};
